module.exports = __webpack_public_path__ + "static/media/report_white.dde78ae8.svg";